import { Tag } from '@ads/components-react';
import { useTranslation } from 'react-i18next';

import { ExamItemStatus } from '../../../types/exam';

export interface QuestionStatusBadgeProps {
  readonly status: ExamItemStatus;
}

const statusMap: Record<
  ExamItemStatus,
  { status: 'default' | 'positive' | 'negative' | 'highlight' }
> = {
  [ExamItemStatus.Pending]: { status: 'highlight' },
  [ExamItemStatus.Approved]: { status: 'positive' },
  [ExamItemStatus.Rejected]: { status: 'negative' },
};

export function QuestionStatusBadge({ status }: QuestionStatusBadgeProps) {
  const { t } = useTranslation('examManagement');
  const key = ExamItemStatus[status] as keyof typeof ExamItemStatus;
  const label = t(`questions.itemStatus.${key}` as never);
  const config = statusMap[status];

  return <Tag label={label} size="sm" status={config.status} custom={{ text: 'text-nowrap' }} />;
}
